var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({paddingLeft: ((_vm.$parent.gutter / 2) + "px"), paddingRight: ((_vm.$parent.gutter / 2) + "px"), flex: _vm.flex, maxWidth: _vm.maxWidth})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }